import { useQuery, useMutation, useQueryClient } from "react-query";
import {
  EvaluationSkillRequestService,
  approveEvaluationSkillRequest,
  rejectEvaluationSkillRequest,
} from "./evaluationSkillRequestService";
import { message } from "antd";

export const useEvaluationSkillRequests = (submissionId, userId) =>
  useQuery(
    ["skill-requests", submissionId, userId],
    () =>
      EvaluationSkillRequestService.getBySubmissionAndUser(
        submissionId,
        userId
      ),
    {
      enabled: !!submissionId && !!userId,
    }
  );


export const useApproveSkillRequest = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, validatedBy }) => approveEvaluationSkillRequest(id, validatedBy),
    {
      onSuccess: () => {
        message.success("Skill request approved");
        queryClient.invalidateQueries("skill-requests");
      },
      onError: () => {
        message.error("Failed to approve request");
      },
    }
  );
};

export const useRejectSkillRequest = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, validatedBy }) => rejectEvaluationSkillRequest(id, validatedBy),
    {
      onSuccess: () => {
        message.success("Skill request rejected");
        queryClient.invalidateQueries("skill-requests");
      },
      onError: () => {
        message.error("Failed to reject request");
      },
    }
  );
};
